import {Space} from "antd";
import {StyledCardCTAButtonWrapper, StyledUpcomingCallCard} from "../../new/styles";
import {
  CancelCallFormValues,
  cancelFormSchema,
  // CoachUpcomingCallJoinVideoCallButton,
  CoachUpcomingCallViewDetailsButton,
  CustomerUpcomingCallJoinVideoCallButton,
  RescheduleCallFormValues,
  rescheduleFormSchema,
  UpcomingCallCardCancelCallDrawer,
  UpcomingCallCardMetaInfo,
  UpcomingCallCardRescheduleCallDrawer,
  UpcomingCallCardViewDetailsDrawer,
} from "../../new";
import {useState} from "react";
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {
  CalendarOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  HourglassOutlined,
  NumberOutlined,
  PhoneOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import {SessionDetailsDrawerBookingQuestionsProps} from "../../../../service/sales-and-insights/customers-section/booking-questions";
import {BookingProvider} from "../../../../../../context/booking/booking-context";
import {GetCustomerUpcomingCallsApiResponseSession} from "../../../../../../react-query-hooks/session/upcoming-calls/types";
import {handleDisplayName} from "../../../../../../utils/profile";

type CustomerUpcomingCallCardProps = {
  session: GetCustomerUpcomingCallsApiResponseSession;
};
export function CustomerUpcomingCallCard({
  session: {
    amount,
    booking_date,
    booking_month,
    booking_year,
    booking_type,
    bookingQuestions,
    bundle_session,
    coach_from_time,
    coach_first_name,
    coach_last_name,
    currency,
    email_address,
    first_name,
    is_bundle,
    last_name,
    phone_number,
    timeslot,
    reference,
    roomId,
    videoPlatform,
    serviceId,
    mentor_timezone,
    coach_username,
    service: {callDuration, no_of_sessions, name, url_redirect},
    coach_display_name,
  },
}: CustomerUpcomingCallCardProps) {
  const coachName = handleDisplayName({
    firstName: coach_first_name,
    lastName: coach_last_name,
    displayName: coach_display_name!,
  });
  const [isViewDetailsDrawerOpen, setIsViewDetailsDrawerOpen] = useState<boolean>(false);
  const [isCancelCallDrawerOpen, setIsCancelCallDrawerOpen] = useState<boolean>(false);
  const [isRescheduleCallDrawerOpen, setIsRescheduleCallDrawerOpen] =
    useState<boolean>(false);
  const cancelCallFormMethods = useForm<CancelCallFormValues>({
    resolver: yupResolver(cancelFormSchema),
    mode: "onChange",
    defaultValues: {
      message: "",
    },
  });
  const rescheduleCallFormMethods = useForm<RescheduleCallFormValues>({
    resolver: yupResolver(rescheduleFormSchema),
    mode: "onChange",
    defaultValues: {
      message: "",
    },
  });
  const cardType = "customer";
  const callAmount = amount === 0 ? "Free" : `${currency} ${amount.toLocaleString()}`;
  const callDate = new Date(
    Number(booking_year),
    Number(booking_month) - 1,
    Number(booking_date)
  ).toDateString();
  const callTime = coach_from_time || timeslot;
  const callDurationText = `${callDuration} minutes`;
  const callLocationIcon =
    booking_type === "video" ? (
      <VideoCameraOutlined style={{color: "#222222"}} />
    ) : (
      <PhoneOutlined style={{color: "#222222"}} />
    );
  const bundleSessions = is_bundle
    ? `| ${bundle_session} of ${no_of_sessions} sessions`
    : "";
  const callLocationText: string =
    booking_type !== "video"
      ? `Phone call ${bundleSessions}`
      : videoPlatform === "googleMeet"
      ? `Google Meet ${bundleSessions}`
      : videoPlatform === "zoom"
      ? `Zoom ${bundleSessions}`
      : `Video call ${bundleSessions}`;

  const cardTitle = `${name} with ${coachName}`;
  function generateCallCardMetaInfo() {
    const baseMetaInfo = [
      {
        icon: <DollarOutlined style={{color: "#222222"}} />,
        value: callAmount,
      },
      {
        icon: <CalendarOutlined style={{color: "#222222"}} />,
        value: callDate,
      },
      {
        icon: <ClockCircleOutlined style={{color: "#222222"}} />,
        value: callTime,
      },
      {
        icon: <HourglassOutlined style={{color: "#222222"}} />,
        value: callDurationText,
      },
      {
        icon: callLocationIcon,
        value: callLocationText,
      },
    ];

    if (booking_type === "audio") {
      return baseMetaInfo.concat([
        {
          icon: <NumberOutlined style={{color: "#222222"}} />,
          value: `${phone_number}`,
        },
      ]);
    } else {
      return baseMetaInfo;
    }
  }
  const callCardMetaInfo = generateCallCardMetaInfo();
  const checkoutFormResponses = JSON.parse(
    bookingQuestions
  ) as SessionDetailsDrawerBookingQuestionsProps["data"];

  function handleRedirectLink() {
    if (url_redirect) {
      return url_redirect.startsWith("http")
        ? {href: url_redirect, name: url_redirect}
        : {name: url_redirect, href: `//${url_redirect}`};
    } else {
      return null;
    }
  }

  const redirectUrl = handleRedirectLink();

  const showViewDetailsDrawer = () => {
    setIsViewDetailsDrawerOpen(true);
  };
  const closeViewDetailsDrawer = () => {
    setIsViewDetailsDrawerOpen(false);
  };
  const showCancelCallDrawer = () => {
    setIsCancelCallDrawerOpen(true);
  };
  const closeCancelCallDrawer = () => {
    setIsCancelCallDrawerOpen(false);
    cancelCallFormMethods.reset();
  };
  const showRescheduleCallDrawer = () => {
    setIsRescheduleCallDrawerOpen(true);
  };
  const closeRescheduleCallDrawer = () => {
    setIsRescheduleCallDrawerOpen(false);
    rescheduleCallFormMethods.reset();
  };

  return (
    <StyledUpcomingCallCard title={cardTitle}>
      <Space direction="vertical" size={16} style={{display: "flex"}}>
        <UpcomingCallCardMetaInfo data={callCardMetaInfo} />
        <StyledCardCTAButtonWrapper>
          <CustomerUpcomingCallJoinVideoCallButton
            bookingType={booking_type}
            phoneNumber={phone_number}
            reference={reference}
            roomId={roomId}
            serviceName={name}
            videoPlatform={videoPlatform}
          />
          <CoachUpcomingCallViewDetailsButton
            showViewDetailsDrawer={showViewDetailsDrawer}
          />
        </StyledCardCTAButtonWrapper>
      </Space>
      <UpcomingCallCardViewDetailsDrawer
        isVisible={isViewDetailsDrawerOpen}
        onClose={closeViewDetailsDrawer}
        title={cardTitle}
        checkoutFormResponses={checkoutFormResponses}
        callMetaInfo={callCardMetaInfo}
        callLocation={booking_type}
        videoPlatform={videoPlatform}
        emailInfo={{
          emailText: "Coach’s name",
          emailValue: coachName,
        }}
        showCancelDrawer={showCancelCallDrawer}
        showRescheduleCallDrawer={showRescheduleCallDrawer}
        redirectUrl={redirectUrl}
      />
      <FormProvider {...cancelCallFormMethods}>
        <UpcomingCallCardCancelCallDrawer
          isVisible={isCancelCallDrawerOpen}
          nameOfPerson={coachName}
          onClose={closeCancelCallDrawer}
          title={cardTitle}
          bookingReference={reference}
          type={cardType}
        />
      </FormProvider>
      {isRescheduleCallDrawerOpen && (
        <FormProvider {...rescheduleCallFormMethods}>
          <BookingProvider>
            <UpcomingCallCardRescheduleCallDrawer
              isVisible={isRescheduleCallDrawerOpen}
              nameOfPerson={coachName}
              onClose={closeRescheduleCallDrawer}
              title={cardTitle}
              bookingReference={reference}
              serviceId={serviceId}
              mentorTimezone={mentor_timezone}
              coachUsername={coach_username}
              type="customer"
            />
          </BookingProvider>
        </FormProvider>
      )}
    </StyledUpcomingCallCard>
  );
}
